import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineMaintenanceEditApi extends BaseClient {
  public doMachineMaintenanceEdit (id: string, bodyData: {[key:string]: string|number|number[]}) {
    const path:string = '/v1/machine-maintenances/' + id

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new MachineMaintenanceEditApi()
